module.exports = __webpack_public_path__ + "img/rainbow.f182fd52.svg";